import Swiper from "swiper";
import { Autoplay, Navigation, Pagination, Thumbs } from "swiper/modules";
import { adjustedPx } from "../../utils/helpers";
export default class Slider {
    constructor(sliderContainer) {
        this.breakpoints = ['xs', 'sm', 'md', 'lg', 'xl'];
        this.sliderContainer = sliderContainer;
        this.initSlider();
    }
    initSlidesPerView(container, attributeName = 'data-slides-per-view') {
        const self = this;
        const slidesPerBreakpoints = {};
        const slidesArray = [];
        if (!container || !container.hasAttribute(attributeName)) {
            return {
                xs: 12,
                sm: 16,
                md: 24,
                lg: 32,
                xl: 32
            };
        }
        const slidesPerViewData = container.getAttribute(attributeName) || null;
        if (slidesPerViewData) {
            const slidesPerView = slidesPerViewData.split(',');
            slidesPerView.forEach((slides, index) => {
                slidesArray.push(parseInt(slides));
            });
        }
        let prevSlidePerView = 1;
        self.breakpoints.forEach((breakpoint, index) => {
            const slidesPerView = slidesArray[index] ? slidesArray[index] : prevSlidePerView;
            slidesPerBreakpoints[breakpoint] = slidesPerView;
            prevSlidePerView = slidesPerView;
        });
        return slidesPerBreakpoints;
    }
    gapsPerView(container, attributeName = 'data-gap-per-view') {
        const gapsPerBreakpoints = {};
        const gapsArray = [];
        if (!container || !container.hasAttribute(attributeName)) {
            return {
                xs: 12,
                sm: 16,
                md: 24,
                lg: 32,
                xl: 32
            };
        }
        const gapsPerViewData = container.getAttribute(attributeName);
        if (gapsPerViewData) {
            const gapsPerView = gapsPerViewData.split(',');
            gapsPerView.forEach((gaps, index) => {
                gapsArray.push(parseInt(gaps));
            });
        }
        let prevSlidePerView = 1;
        this.breakpoints.forEach((breakpoint, index) => {
            const gapsPerView = gapsArray[index] ? gapsArray[index] : prevSlidePerView;
            gapsPerBreakpoints[breakpoint] = gapsPerView;
            prevSlidePerView = gapsPerView;
        });
        return gapsPerBreakpoints;
    }
    initSlider() {
        const self = this;
        const slidesPerBreakpoints = this.initSlidesPerView(this.sliderContainer);
        const gapsPerBreakpoints = this.gapsPerView(this.sliderContainer);
        const slider = self.sliderContainer.querySelector('.swiper');
        const navigation = self.sliderContainer.querySelector('.main-navigation');
        const paginationEl = self.sliderContainer.querySelector('.swiper-pagination');
        let paginationType = null;
        const thumbsSlider = self.sliderContainer.querySelector('.swiper.slider-thumbs');
        const thumbNavigation = thumbsSlider ? self.sliderContainer.querySelector('.thumb-navigation') : null;
        const loop = self.sliderContainer.hasAttribute('data-loop');
        const autoplay = self.sliderContainer.hasAttribute('data-autoplay');
        const sm = adjustedPx(576);
        const md = adjustedPx(744);
        const lg = adjustedPx(992);
        const xl = adjustedPx(1200);
        let thumbsSwiper = null;
        if (thumbsSlider) {
            const thumbsSlidesPerBreakpoints = this.initSlidesPerView(thumbsSlider);
            const thumbsGapsPerBreakpoints = this.gapsPerView(thumbsSlider);
            let thumbOptions = {
                spaceBetween: 10,
                slidesPerView: thumbsSlidesPerBreakpoints['xs'],
                watchSlidesProgress: true,
                modules: [],
                breakpoints: {
                    [sm]: {
                        slidesPerView: thumbsSlidesPerBreakpoints['sm'],
                        spaceBetween: thumbsGapsPerBreakpoints['sm'] ? thumbsGapsPerBreakpoints['sm'] : 16
                    },
                    [md]: {
                        slidesPerView: thumbsSlidesPerBreakpoints['md'],
                        spaceBetween: thumbsGapsPerBreakpoints['md'] ? thumbsGapsPerBreakpoints['md'] : 24
                    },
                    [lg]: {
                        slidesPerView: thumbsSlidesPerBreakpoints['lg'],
                        spaceBetween: thumbsGapsPerBreakpoints['lg'] ? thumbsGapsPerBreakpoints['lg'] : 32
                    },
                    [xl]: {
                        slidesPerView: thumbsSlidesPerBreakpoints['xl'],
                        spaceBetween: thumbsGapsPerBreakpoints['xl'] ? thumbsGapsPerBreakpoints['xl'] : 32
                    }
                }
            };
            if (thumbNavigation) {
                const thumbNavigationNextEl = thumbNavigation.querySelector('.swiper-button-next');
                const thumbNavigationPrevEl = thumbNavigation.querySelector('.swiper-button-prev');
                thumbOptions.modules.push(Navigation);
                thumbOptions["navigation"] = {
                    nextEl: thumbNavigationNextEl,
                    prevEl: thumbNavigationPrevEl
                };
            }
            thumbsSwiper = new Swiper(thumbsSlider, thumbOptions);
        }
        let options = {
            spaceBetween: 8,
            slidesPerView: slidesPerBreakpoints['xs'],
            loop: loop,
            autoplay: autoplay,
            modules: [],
            breakpoints: {
                [sm]: {
                    slidesPerView: slidesPerBreakpoints['sm'],
                    spaceBetween: gapsPerBreakpoints['sm'] ? gapsPerBreakpoints['sm'] : 16
                },
                [md]: {
                    slidesPerView: slidesPerBreakpoints['md'],
                    spaceBetween: gapsPerBreakpoints['md'] ? gapsPerBreakpoints['md'] : 24
                },
                [lg]: {
                    slidesPerView: slidesPerBreakpoints['lg'],
                    spaceBetween: gapsPerBreakpoints['lg'] ? gapsPerBreakpoints['lg'] : 32
                },
                [xl]: {
                    slidesPerView: slidesPerBreakpoints['xl'],
                    spaceBetween: gapsPerBreakpoints['xl'] ? gapsPerBreakpoints['xl'] : 32
                }
            }
        };
        if (autoplay) {
            options.modules.push(Autoplay);
        }
        if (navigation) {
            const navigationNextEl = navigation.querySelector('.swiper-button-next');
            const navigationPrevEl = navigation.querySelector('.swiper-button-prev');
            options.modules.push(Navigation);
            options["navigation"] = {
                nextEl: navigationNextEl,
                prevEl: navigationPrevEl
            };
        }
        if (paginationEl) {
            options.modules.push(Pagination);
            options["pagination"] = {
                el: paginationEl,
                clickable: true
            };
            paginationType = paginationEl.getAttribute('data-pagination-type');
            if (paginationType) {
                options["pagination"]["type"] = paginationType;
            }
        }
        if (thumbsSwiper) {
            options.modules.push(Thumbs);
            options["thumbs"] = {
                swiper: thumbsSwiper
            };
        }
        const mainSlider = new Swiper(slider, options);
        if (thumbsSwiper) {
            // Fix for tab + enter on thumbs buttons
            const thumbButtons = thumbsSlider.querySelectorAll('button');
            thumbButtons.forEach((button, index) => {
                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    mainSlider.slideTo(index);
                });
            });
            if (paginationEl && paginationType === 'fraction') {
                // Calculate the width of the pagination fraction - used to create perfect gap for mobile navigation
                const current = paginationEl.querySelector('.swiper-pagination-current');
                const total = paginationEl.querySelector('.swiper-pagination-total');
                const currentWidth = current.offsetWidth;
                const totalWidth = total.offsetWidth;
                const totalPaginationWidth = currentWidth + totalWidth;
                // Set CSS variable on the slider container
                this.sliderContainer.style.setProperty('--pagination-width', `${totalPaginationWidth}px`);
            }
        }
    }
}
